export const watch = {
  step() {
    this.checkPreventions()
  }
}
